/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefetchContainer_regionalInfo$ref: FragmentReference;
export type SbSharedRefetchContainer_regionalInfo = $ReadOnlyArray<{|
  +regionsByZipCode: ?$ReadOnlyArray<?{|
    +displayName: ?string,
    +urlLabel: ?string,
  |}>,
  +$refType: SbSharedRefetchContainer_regionalInfo$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefetchContainer_regionalInfo",
  "type": "RegionalInfo",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "regionsByZipCode",
      "storageKey": null,
      "args": null,
      "concreteType": "RegionsByZipCode",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c3f7ac30a90500c6a81ef4813b5a69f4';
module.exports = node;
